import React, { useEffect } from 'react';
import { m, AnimatePresence } from 'framer-motion';
import { LoaderSpinner } from './LoaderSpinner';

interface PreloaderProps {
    isLoading: boolean;
}

export const Preloader: React.FC<PreloaderProps> = ({ isLoading }) => {
    useEffect(() => {
        if (isLoading) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isLoading]);

    return (
        <AnimatePresence>
            {isLoading && (
                <m.div
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                    className="fixed inset-0 z-[100] flex items-center justify-center bg-[#050c15]"
                >
                    <LoaderSpinner />
                </m.div>
            )}
        </AnimatePresence>
    );
};
